import type { AxiosRequestHeaders } from 'axios';

import type { ITokenData } from './types';

/**
 * 为请求 body 补充 iframe 承接页所需的上下文字段（game_code、dashboard_id）。
 */
export const appendIframeWireBodyFields = (
  tokenData: ITokenData,
  body: Record<string, unknown>,
): Record<string, unknown> => {
  const nextBody = { ...body };
  delete nextBody.system;
  return {
    ...nextBody,
    game_code: tokenData.gameCode,
    dashboard_id: tokenData.dashboardId,
  };
};

/**
 * 为请求 headers 注入 iframe guest Authorization。
 */
export const appendIframeAuthorizationHeader = (
  token: string,
  headers?: AxiosRequestHeaders,
): AxiosRequestHeaders => ({
  ...headers,
  Authorization: token,
});
